module.exports = {
  isNullOrWhiteSpace(str) {
    return str == null || str.trim() === "";
  },
};
